module.exports = {
  apiHost: "https://api.senses.sensoreal.app",
  assetsHost: "https://assets.senses.sensoreal.app",
};
